import { useEffect, useState } from 'react'
import { cn } from '@/lib/utils'

type LandingAsciiVisualProps = {
  artId: string
  className?: string
  decorative?: boolean
  ariaLabel?: string
}

/** Loads static art from `labs/public/ascii/{artId}.txt` — no runtime generation. */
export function LandingAsciiVisual({
  artId,
  className,
  decorative = true,
  ariaLabel,
}: LandingAsciiVisualProps) {
  const [text, setText] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    fetch(`/ascii/${encodeURIComponent(artId)}.txt`)
      .then((r) => (r.ok ? r.text() : ''))
      .then((body) => {
        if (!cancelled) setText(body.trim() || null)
      })
      .catch(() => {
        if (!cancelled) setText(null)
      })
    return () => {
      cancelled = true
    }
  }, [artId])

  if (!text) return null

  return (
    <pre
      className={cn(
        'max-w-full overflow-x-auto whitespace-pre font-mono text-[0.65rem] leading-tight text-muted-foreground sm:text-xs',
        className
      )}
      {...(decorative ? { 'aria-hidden': true } : { role: 'img', 'aria-label': ariaLabel ?? 'Decorative illustration' })}
    >
      {text}
    </pre>
  )
}
